// import Vue from 'vue'
import { createApp } from 'vue'

import App from './App.vue'
import logger from '@/plugin/logger.ts'

import common from '@/assets/js/common'

import store from '@/store/index'

import router from '@/router'

import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3000'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.withCredentials = true // 쿠키를 포함한 요청을 허용

// GA
import VueGtag from 'vue-gtag'


import { 
  Quasar, Notify, Dialog, ClosePopup, Ripple,
  QBtn, QCard, QInput, QTable, QIcon, QDialog, QSelect, QCheckbox, 
  QRadio, QToggle, QDate, QTime, QToolbar, QToolbarTitle, QHeader, QFooter, QDrawer, 
  QLayout, QPage, QPageContainer, QTabs, QTab, QTabPanels, QTabPanel, QSeparator, 
  QAvatar, QTooltip, QMenu, QPagination, QSpinner, QBadge, QChip, QBanner, QExpansionItem, 
  QForm, QField, QItem, QItemSection, QItemLabel, QImg, QSpace, QScrollArea, QLinearProgress,
  QStepper, QStep, QStepperNavigation, QOptionGroup, QSlider, QRange, QBtnDropdown, QBtnGroup, 
  QBtnToggle, QCarousel, QCarouselSlide, QCarouselControl, QTh, QTr, QTd, QTree, QTimeline, 
  QTimelineEntry, QVideo, QEditor, QList, QPopupProxy, QMarkupTable, QResizeObserver,
  QCardSection, QUploader, QCardActions,
  QSlideTransition
} from 'quasar'
// import * as AllQuasarComponents from 'quasar'

import 'quasar/dist/quasar.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@/assets/style/common.scss'

const app = createApp(App)

app.use(logger)
app.use(router)
app.use(store)
app.use(common)
app.use(VueGtag, {
  appName: 'Aone logistics',
  pageTrackerScreenviewEnabled: true,
  config: { 
    id: process.env.VUE_APP_GTAG
  }
}, router)
app.use(Quasar,{
  plugins: {
    Notify,
    Dialog
  },
  config: {
    notify: {
      position: 'top',
      timeout: 2500,
      actions: [{ icon: 'close', color: 'white' }]
    }
  },
  directives: {
    ClosePopup,
    Ripple
  },
  components: {
    QBtn,
    QCard,
    QInput,
    QTable,
    QIcon,
    QDialog,
    QSelect,
    QCheckbox,
    QRadio,
    QToggle,
    QDate,
    QTime,
    QToolbar,
    QToolbarTitle,
    QHeader,
    QFooter,
    QDrawer,
    QLayout,
    QPage,
    QPageContainer,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QSeparator,
    QAvatar,
    QTooltip,
    QMenu,
    QPagination,
    QSpinner,
    QBadge,
    QChip,
    QBanner,
    QExpansionItem,
    QForm,
    QField,
    QItem,
    QItemSection,
    QItemLabel,
    QImg,
    QSpace,
    QScrollArea,
    QLinearProgress,
    QStepper,
    QStep,
    QStepperNavigation,
    QOptionGroup,
    QSlider,
    QRange,
    QBtnDropdown,
    QBtnGroup,
    QBtnToggle,
    QCarousel,
    QCarouselSlide,
    QCarouselControl,
    QTh,
    QTr,
    QTd,
    QTree,
    QTimeline,
    QTimelineEntry,
    QVideo,
    QEditor,
    QList,
    QPopupProxy,
    QMarkupTable,
    QResizeObserver,
    QCardSection,
    QUploader,
    QCardActions,
    QSlideTransition
  }
})
app.config.errorHandler = (err, instance, info) => {
  console.error("Vue Global Error:", err, info);
  // 필요하다면 axios로 서버에 전송
  axios.post('/api/log', {
    level: 'error',
    message: err.message,
    stack: err.stack,
    meta: { info }
  }).catch(() => {})
};

app.mount('#app')
